// @ts-nocheck
import { ReactComponent as Icon } from '../../assets/icons/contractIcon.svg';

export default function () {
  return <Icon className="MuiSvgIcon-root" alt="Contract" aria-label="Contract" />;
}
